import React from 'react'
import PropTypes from 'prop-types'

import LoadingBox from 'src/ui/LoadingBox/LoadingBox'
import LevelAssessmentCardPlaceholder from 'src/pages/LearningLanguageLevelAssessment/subcomponents/LevelAssessmentCard/LevelAssessmentCardPlaceholder'

import LearningLanguageLevelAssessmentSkeleton from './LearningLanguageLevelAssessmentSkeleton'

const LearningLanguageLevelAssessmentPlaceholder = ({
  displayPlacementTest,
}) => {
  return (
    <LearningLanguageLevelAssessmentSkeleton
      LogoSection={<LoadingBox width="150px" height="50px" />}
      SelfAssessmentSection={<LevelAssessmentCardPlaceholder open />}
      PlacementTestSection={
        !!displayPlacementTest && <LevelAssessmentCardPlaceholder />
      }
    />
  )
}

LearningLanguageLevelAssessmentPlaceholder.propTypes = {
  displayPlacementTest: PropTypes.bool,
}
export default LearningLanguageLevelAssessmentPlaceholder
